import { Pipe, PipeTransform } from '@angular/core';
import { DashboardCardsEnum } from '../enums';

@Pipe({
    name: 'visibleCardCount',
    standalone: false
})
export class VisibleCardsCountrPipe implements PipeTransform {
    transform(
        value: { [key in DashboardCardsEnum]: boolean },
        disableCards: { [key in DashboardCardsEnum]: boolean }
    ): number {
        return Object.entries(value)
            .filter(([key, isVisible]) => isVisible && disableCards?.[key as DashboardCardsEnum]).length;
    }
}
